<template>
	<div class="managementStore">
		<div class="isFlexCenter">
			<div class="myform">
				<div class="title">
					<div>
						我的店铺
						<el-link type="primary" @click="sellCenterListDialog = true"> <i class="el-icon-refresh"></i>店铺管理</el-link>
					</div>
					<el-button type="primary" size="mini" @click="editShop" v-if="form.checkStatus && form.updateStatus !== 1">重新装潢</el-button>
					<el-tag type="warning" v-else-if="form.updateStatus === 1"> 已提交装潢申请，请耐心等待中心审核，可到店铺管理查看审核进度</el-tag>
				</div>
				<el-form ref="form" :model="form" label-width="100px" size="small" :rules="rules" :disabled="form.checkStatus">
					<el-form-item class="inputwidth" label="店铺名称" prop="shopName">
						<el-input v-model="form.shopName"></el-input>
					</el-form-item>
					<el-form-item class="inputwidth" label="店铺logo" prop="shopLogo">
						<el-upload class="avatar-uploader" :action="this.$const.common.fileUpload" :show-file-list="false" :on-success="handleLOGOSuccess" :before-upload="beforeAvatarUpload">
							<img :src="`${form.shopLogo || shopLogoImg}`" class="avatar" />
							<div class="el-upload__tip" slot="tip">建议尺寸：长200像素，宽200像素；图片大小不超过300K</div>
						</el-upload>
					</el-form-item>
					<el-form-item class="inputwidth" label="店铺Banner" prop="shopBanner">
						<el-upload class="avatar-uploader" :action="this.$const.common.fileUpload" :show-file-list="false" :on-success="handleBannerSuccess" :before-upload="beforeAvatarUpload">
							<img :src="`${form.shopBanner || shopTopImg}`" class="avatar-long" />
							<div class="el-upload__tip" slot="tip">建议尺寸：长1920像素，宽400像素；图片大小不超过300K</div>
						</el-upload>
					</el-form-item>
					<el-form-item class="inputwidth" label="店铺展示图" prop="shopBackground">
						<el-upload class="avatar-uploader" :action="this.$const.common.fileUpload" :show-file-list="false" :on-success="handleBGSuccess" :before-upload="beforeAvatarUpload">
							<img :src="`${form.shopBackground || shopDisplay}`" class="avatar-square" />
							<div class="el-upload__tip" slot="tip">建议尺寸：长600像素，宽300像素；图片大小不超过300K<br /></div>
						</el-upload>
					</el-form-item>
					<el-form-item label="服务时间" prop="serviceDate">
						<el-select v-model="form.serviceDate" multiple placeholder="请选择" style="display: block; width: 460px; margin-bottom: 12px">
							<el-option v-for="item in businessWeek" :label="item" :value="item"></el-option>
						</el-select>
						<el-time-select placeholder="起始时间" v-model="form.serviceBeginTime" style="margin-right: 12px" :picker-options="{ start: '00:00:00', step: '1:00:00', end: '24:00:00' }">
						</el-time-select
						>-
						<el-time-select
							placeholder="结束时间"
							v-model="form.serviceEndTime"
							style="margin-left: 12px"
							:picker-options="{ start: '00:00:00', step: '1:00:00', end: '24:00:00', minTime: form.serviceBeginTime }"
						>
						</el-time-select>
					</el-form-item>
					<el-form-item class="inputwidth" label="服务热线" prop="serviceHotline">
						<el-input v-model="form.serviceHotline"></el-input>
					</el-form-item>
					<el-form-item class="inputwidth" label="电子邮件" prop="shopEmail">
						<el-input v-model="form.shopEmail"></el-input>
					</el-form-item>
					<el-form-item label="店铺简介" prop="shopIntroduce">
						<el-input type="textarea" v-model="form.shopIntroduce" :rows="4"></el-input>
					</el-form-item>
					<div class="shop-edit-box">
						<div class="shop-edit-label">
							<span>高级编辑</span>
							<div><i class="el-icon-info"></i>建议在全屏模式下编译，以获得更好的展示效果</div>
						</div>
						<div id="editBox"></div>
					</div>
					<el-form-item v-if="!(form.checkStatus > 0 && form.updateStatus)">
						<el-button type="primary" @click="submitForm('form')">提交</el-button>
						<el-button @click="resetForm('form')">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div>
			<el-dialog title="店铺变更记录" :visible.sync="sellCenterListDialog" :close-on-click-modal="false" v-dialogDrag width="70%" top="5vh">
				<sellCenterChangeList v-if="sellCenterListDialog" @sellCenterListDialogSuccess="sellCenterListDialogSuccess"> </sellCenterChangeList>
			</el-dialog>
		</div>
	</div>
</template>

<script>
import E from 'wangeditor'
import hljs from 'highlight.js'
import sellCenterChangeList from '@/components/DialogComponent/sellCenterChangeList'
import shopLogoImg from '../../../assets/imgs/logo.png'
import shopTopImg from '../../../assets/imgs/RemoteSensingMall/companyInfoBanner.png'
import shopDisplay from '../../../assets/imgs/RemoteSensingMall/shop/shop-display.png'

export default {
	name: 'managementStore',
	components: { sellCenterChangeList },
	props: {},
	data() {
		var checkPhone = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入服务热线'))
			} else {
				let regPone = null
				let mobile = /^1(3|4|5|6|7|8|9)\d{9}$/ //最新16手机正则
				let tel = /^(0[0-9]{2,3}\-)([2-9][0-9]{4,7})+(\-[0-9]{1,4})?$/ //座机
				if (value.charAt(0) == 0) {
					// charAt查找第一个字符方法，用来判断输入的是座机还是手机号
					regPone = tel
				} else {
					regPone = mobile
				}
				if (!regPone.test(value)) {
					return callback(new Error("请填写服务热线(座机格式'区号-座机号码')"))
				}
				callback()
			}
		}

		return {
			shopLogoImg,
			shopTopImg,
			shopDisplay,
			sellCenterListDialog: false,
			ChangeStoreInfo: {},
			businessWeek: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
			editor: {},
			form: {
				shopName: '', // 店铺名称
				shopLogo: '', // 店铺logo
				shopBanner: '', // 店铺Banner
				shopBackground: '', //	店铺背景图

				serviceDate: [], //	店铺服务周期，以英文逗号隔开
				serviceBeginTime: '', //店铺服务开始时间
				serviceEndTime: '', //	店铺服务结束时间

				serviceHotline: '', //店铺服务热线
				shopEmail: '', //电子邮件

				shopIntroduce: '', //店铺简介
				decoration: '' // 店铺高级编辑
			},

			rules: {
				shopName: [{ required: true, message: '请输入店铺名称', trigger: 'blur' }],
				shopLogo: [{ required: true, message: '请上传店铺logo' }],
				// shopBanner: [{ required: true, message: '请上传店铺的顶部图片' }],
				// shopBackground: [{ required: true, message: '请上传店铺的展示图片' }],
				serviceHotline: [{ required: true, validator: checkPhone, trigger: 'blur' }],
				shopEmail: [
					{ required: true, message: '请输入邮箱', trigger: 'blur' },
					{ pattern: /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g, message: '请输入正确的邮箱', trigger: 'blur' }
				],
				shopIntroduce: [{ required: true, message: '请填写店铺简介', trigger: 'blur' }]
			}
		}
	},
	computed: {},
	watch: {},
	mounted() {
		this.initEditor()

		this.$http
			.get(this.$const.SellerCenter.shopGetView, '', true)
			.then((res) => {
				console.log(res)
				if (res.data) {
					this.form = res.data
					this.form.serviceDate = this.form.serviceDate.split(',')
					this.editor.txt.html(this.form.decoration)

					if (this.form.checkStatus) this.editor.disable()
				}
			})
			.catch((error) => {
				this.$message.warning('获取用户店铺信息失败!')
				console.log(error)
			})
	},
	methods: {
		handleLOGOSuccess(res, file) {
			this.form.shopLogo = res.data
		},
		handleBannerSuccess(res, file) {
			this.form.shopBanner = res.data
		},
		handleBGSuccess(res, file) {
			this.form.shopBackground = res.data
		},
		beforeAvatarUpload(file) {
			const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/PNG' || file.type === 'image/JPG'
			const isLt2M = file.size / 1024 < 5000
			if (!isJPG) {
				this.$message.error('上传图片只能是 JPG 或 PNG 格式!')
			}
			if (!isLt2M) {
				this.$message.error('上传图片大小不能超过 5M !')
			}
			return isJPG && isLt2M
		},
		editShop() {
			// 编辑店铺
			this.form.checkStatus = null
			this.editor.enable()
		},
		submitForm(formName) {
			if (this.form.updateStatus === 1) {
				console.error('店铺审核中,请耐心等待...')
				return false
			}
			console.log(this.form)
			this.$refs[formName].validate((valid) => {
				if (valid) {
					if (this.form.serviceBeginTime && this.form.serviceBeginTime.split(':').length === 2) this.form.serviceBeginTime += ':00'
					if (this.form.serviceEndTime && this.form.serviceEndTime.split(':').length === 2) this.form.serviceEndTime += ':00'
					this.form.serviceDate = this.form.serviceDate.join(',')
					delete this.form.checkStatus
					this.$http
						.put(this.$const.SellerCenter.EDITshopSave, this.form, true)
						.then((res) => {
							this.$message.success('提交店铺信息成功,页面即将刷新')
							var that = this
							setTimeout(function () {
								that.$router.go(0)
							}, 1500)
						})
						.catch((error) => {
							this.$message.success('提交店铺信息失败')
							console.log(error)
						})
				} else {
					return false
				}
			})
		},
		resetForm(formName) {
			this.$refs[formName].resetFields()
			this.editor.txt.clear()
		},
		sellCenterListDialogSuccess(e) {
			if (e) {
				let jsonP = JSON.parse(e)
				this.ChangeStoreInfo = jsonP
			} else {
				this.ChangeStoreInfo = this.form
			}
			this.sellCenterListDialog = false
		},
		initEditor() {
			var _this = this
			this.editor = new E('#editBox')
			// 配置菜单栏，设置不需要的菜单
			// this.editor.config.showFullScreen = false;
			// // 设置编辑器高度
			if (document.body.clientWidth > 1400) {
				this.editor.config.height = 300
			} else {
				this.editor.config.height = 200
			}
			this.editor.config.onchange = function (e) {
				_this.form.decoration = e
			}
			// 代码高亮
			this.editor.highlight = hljs
			// 一次最多上传 1 个图片
			this.editor.config.uploadImgMaxLength = 1
			// 隐藏网络图片入口
			this.editor.config.showLinkImg = false
			//圖片上传地址
			this.editor.config.uploadImgServer = this.$const.common.fileUpload
			// 图片上传header参数设置
			// this.editor.config.uploadImgHeaders = _this.myHeaders;
			// 自定义参数名称
			this.editor.config.uploadFileName = 'file'
			//输入内容-触发时间为500ms每次
			this.editor.config.onchangeTimeout = 500
			// 默认限制图片上传大小为5M
			this.editor.config.uploadImgHooks = {
				customInsert: function (insertImgFn, result) {
					// result 即服务端返回的接口
					// console.log('customInsert', result)
					if (result.code == 200) {
						let imgUrl = result.data
						// insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
						insertImgFn(imgUrl)
					}
				}
			}
			this.editor.config.uploadVideoHeaders = this.myVideoHaders
			// 配置视频上传地址
			this.editor.config.uploadVideoServer = this.$const.common.fileUpload

			this.editor.config.uploadVideoName = 'file'
			// this.editor.config.uploadVideoHooks = {
			// 	success: function(xhr) {
			// 	console.log('success', xhr)
			// 	},
			// }
			this.editor.config.uploadVideoHooks = {
				customInsert: function (insertImgFn, result) {
					// result 即服务端返回的接口
					// console.log('customInsert', result)
					if (result.code == 200) {
						let imgUrl = result.data
						// insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
						insertImgFn(imgUrl)
					}
				}
			}
			this.editor.create()
			console.log(1111, this.editor.config)

			// 商品编辑功能 内容展示
			// if (this.$route.query.id) {
			// 	this.editID = this.$route.query.id;
			// 	// 加载当前商品数据
			// 	this.$http.get(this.$const.common.getShopGoodsDesc + this.editID).then((res) => {
			// 		if (res.code === 200) {
			// 			this.Myform = res.data;

			// 			this.acceptCityInfo = [
			// 				this.Myform.goodsInfo.provinceName, this.Myform.goodsInfo.cityName, this.Myform.goodsInfo.countyName
			// 			];

			// 			this.selectbuttons = this.Myform.goodsInfo.productPlateId

			// 			this.fileList = [{
			// 				name: this.Myform.goodsInfo.goodsName + '说明文档',
			// 				url: this.Myform.goodsInfo.goodsDocUrl
			// 			}];
			// 			this.goodsInfo_endDate = this.Myform.goodsInfo.endDate;
			// 			if (this.Myform.goodsInfo.endDate == '' || this.Myform.goodsInfo.endDate == null) {
			// 				this.long_term_effective = true;
			// 			}
			// 			if (this.Myform.goodsInfo.deliveryDate == '' || this.Myform.goodsInfo.deliveryDate == null) {
			// 				this.deliveryDate = '实时'
			// 			} else {
			// 				this.deliveryDate = '天'
			// 				this.day = this.Myform.goodsInfo.deliveryDate;
			// 			}
			// 			this.editor.txt.html(this.Myform.goodsExtension.goodsProductIntroduction);
			// 			var imgList = this.Myform.goodsExtension.goodsImg.split(',')
			// 			imgList.forEach((item, i) => {
			// 				if (item != '') {
			// 					this.GoodsImgFileList.push({ name: item, url: item })
			// 				}
			// 			})

			// 		}
			// 	})

			// }
		}
	}
}
</script>

<style lang="scss" scoped>
.managementStore {
	.myform {
		.title {
			display: flex;
			align-items: flex-end;
			justify-content: space-between;
			margin-top: 12px;
			margin-bottom: 25px;
			font-size: 22px;

			.el-link {
				margin-left: 12px;
			}
		}

		.el-form-item {
			margin: 24px 0;

			&.inputwidth {
				width: 500px;
			}
			::v-deep .el-form-item__error {
				font-size: 16px;
				font-weight: 700;
			}
			.el-upload__tip {
				color: #919191;
			}
			.avatar-long {
				display: block;
				width: 520px;
				height: 120px;
			}
			.avatar-square {
				display: block;
				width: 160px;
				height: 120px;
			}
		}

		.shop-edit-box {
			> .shop-edit-label {
				> span {
					display: inline-block;
					padding-right: 12px;
					width: 100px;
					color: #606266;
					font-size: 14px;
					text-align: right;
					line-height: 32px;
				}
				> div {
					display: inline-block;
					color: #606266;
					font-size: 14px;
					> i {
						margin-right: 6px;
					}
				}
			}
			> #editBox {
				margin-left: 100px;
			}
		}
	}
}
</style>

<style>
.avatar-uploader .el-upload {
	position: relative;
	border: 1px dashed;
	border-color: #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	overflow: hidden;
}

.avatar-uploader .el-upload:hover {
	border-color: #409eff;
}

.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 120px;
	height: 120px;
	line-height: 120px;
	text-align: center;
}

.avatar {
	display: block;
	width: 120px;
	height: 120px;
}
</style>